var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGenderWomen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 37,
    viewBox: "0 0 29 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3062 17.6926C22.9216 16.0003 24.6139 13.6926 24.6139 11.2311C24.6139 5.92338 21.0754 2.46184 17.6908 1.0003C17.3062 0.846454 16.9985 0.769531 16.537 0.769531C15.6908 0.769531 14.9216 1.15415 14.3831 1.76953C13.8447 1.15415 13.0754 0.769531 12.2293 0.769531C11.8447 0.769531 11.46 0.846454 11.0754 1.0003C7.76773 2.46184 4.15234 6.0003 4.15234 11.2311C4.15234 13.7695 5.84465 16.0003 7.46004 17.6926",
    stroke: "#00C9B8",
    strokeWidth: 1.53846,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.61581 17.9219C4.00043 20.1526 4.00043 21.0757 4.84658 23.1526C6.07735 26.1526 7.46196 26.6142 7.46196 31.3065C10.462 31.3065 12.2312 28.6911 12.2312 23.4603",
    stroke: "#00C9B8",
    strokeWidth: 1.53846,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0742 22.4609C18.0742 32.4609 27.9973 28.6148 27.9973 34.4609",
    stroke: "#2E63EE",
    strokeWidth: 1.53846,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.61569 30.4609C1.61569 31.1532 0.769531 32.1532 0.769531 34.4609",
    stroke: "#2E63EE",
    strokeWidth: 1.53846,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.769531 34.3867C4.0003 35.3098 8.69261 35.9252 13.8465 35.9252H14.9234C20.0772 35.9252 24.7695 35.3098 28.0003 34.3867",
    stroke: "#2E63EE",
    strokeWidth: 1.53846,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6902 10.3858C21.9979 11.155 22.1517 12.0012 22.1517 12.9243C22.1517 18.4627 18.3056 24.0781 14.3825 24.0781C10.4594 24.0781 6.61328 18.4627 6.61328 12.9243C6.61328 8.15505 18.0748 9.38582 18.0748 6.07812",
    stroke: "#2E63EE",
    strokeWidth: 1.53846,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenderWomen);
export default __webpack_public_path__ + "static/media/Gender_Women.310f3b1b43e3ac59b1be1eed2bab0f63.svg";
export { ForwardRef as ReactComponent };